<div class="file-details-panel">
    <div class="panel-header">
      <h2>File Details</h2>
      <button type="button" class="btn-close" (click)="close()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
    @if (loading) {
      <div class="panel-state loading-state" aria-live="polite">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Loading file details...</p>
      </div>
    } @else if (errorMessage) {
      <div class="panel-state error-state" role="alert">
        <i class="fas fa-circle-exclamation"></i>
        <h3>File details unavailable</h3>
        <p>{{ errorMessage }}</p>
        <button type="button" class="btn btn-primary" (click)="retry()">Try again</button>
      </div>
    } @else if (fileDetails) {
    <div class="panel-content">
      <!-- File Name -->
      <h3 class="file-name">{{ fileDetails.filename }}</h3>
      <!-- File Preview -->
      <div class="file-preview">
        @if (isImageFile(fileDetails.extension) && imageUrl$) {
          @if (imageUrl$ | async; as imageUrl) {
            <div class="image-preview">
              <img [src]="imageUrl" [alt]="fileDetails.filename"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
              <div class="preview-placeholder" style="display: none;">
                <i class="fas {{ getFileIcon(fileDetails.extension) }}"></i>
              </div>
            </div>
          }
        }
        @if (!isImageFile(fileDetails.extension)) {
          <button type="button" class="preview-placeholder clickable"
            (click)="openFile(fileDetails)">
            <i class="fas {{ getFileIcon(fileDetails.extension) }}" aria-hidden="true"></i>
            <span class="open-file-text">{{ fileOpenError ? 'Try opening again' : 'Click to view' }}</span>
          </button>
        }
      </div>
      @if (fileOpenError) {
        <div class="alert alert-danger" role="alert">{{ fileOpenError }}</div>
      }
        <!-- Related Assets -->
        @if (fileDetails.relatedAssets?.length) {
          <div class="related-assets">
            <h3>USED IN</h3>
            <div class="asset-list">
              @for (asset of fileDetails.relatedAssets; track asset) {
                <div class="asset-item">
                  <!-- Assets Section -->
                  <h4>ASSETS</h4>
                  <div class="asset-content">
                    <div class="asset-type-header">
                      <i class="fas fa-cube"></i>
                      <span>{{ asset.assetTypeName }}</span>
                    </div>
                    <div class="asset-list-inner">
                      <a href="#" (click)="onAssetClick($event, asset.assetId, asset.assetTypeId)"
                        class="asset-link">
                        <i class="fas {{ getFileIcon(fileDetails.extension) }}"></i>
                        <span class="asset-name">{{ asset.assetName }}</span>
                        <span class="file-type-badge">{{ getFileTypeLabel(fileDetails.extension) }}</span>
                      </a>
                    </div>
                  </div>
                  <!-- Features Section -->
                  @if (getScenes(asset).length) {
                    <div class="features-section">
                      <h4>FEATURES</h4>
                      @for (scene of getScenes(asset); track scene) {
                        <div class="scene-item">
                          <div class="scene-header">
                            <i class="fas fa-map-marked-alt"></i>
                            <span>{{ scene.sceneName }}</span>
                            <span class="project-name">in {{ scene.projectName }}</span>
                          </div>
                          <!-- Features in this Scene -->
                          @if (getFeaturesForScene(asset, scene.sceneId).length) {
                            <div class="feature-list">
                              @for (feature of getFeaturesForScene(asset, scene.sceneId); track feature) {
                                <a
                                  [href]="getFeatureUrl(scene.projectId, scene.sceneId, feature.featureId)"
                                  (click)="onFeatureClick($event, scene.projectId, scene.sceneId, feature.featureId)"
                                  target="_blank" class="feature-link">
                                  <shared-feature-icon [type]="feature.featureType"></shared-feature-icon>
                                  <span class="feature-name">{{ feature.featureName }}</span>
                                </a>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <!-- No Related Assets Message -->
        @if (!fileDetails.relatedAssets?.length) {
          <div class="no-assets-message">
            <i class="fas fa-info-circle"></i>
            <p>This file is not currently used in any assets.</p>
          </div>
        }
        <!-- File Info -->
        <div class="file-info">
          @if (fileDetails.aiDescription) {
            <div class="ai-description-section">
              <button class="ai-description-toggle" (click)="toggleAiDescription()">
                <i class="fas" [class.fa-chevron-right]="!showAiDescription"
                [class.fa-chevron-down]="showAiDescription"></i>
                <i class="fas fa-robot"></i>
                <span>AI Description</span>
              </button>
              @if (showAiDescription) {
                <p class="ai-description">
                  {{ fileDetails.aiDescription }}
                </p>
              }
            </div>
          }
          <div class="metadata">
            <div class="metadata-item">
              <span class="label">Size:</span>
              <span class="value">{{ formatFileSize(fileDetails.size) }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Backdrop -->
  <div class="panel-backdrop" (click)="close()"></div>
